module.exports = __webpack_public_path__ + "img/nosotros.85679e3d.svg";